function objectEquals (_this = {}, _that = {}) {
  return Object.keys(_this).every(_thisKey =>
      _thisKey in _that && _this[_thisKey] === _that[_thisKey]
    );
}

export default objectEquals;



// WEBPACK FOOTER //
// ./src/cart/actions/helpers/objectEquals.js